/**
 * Same as `legacyId` but will throw if from is not an ID thingy.
 *
 * @param from
 * @returns
 */
export function legacyIdX(from: any): string {
  const value = legacyId(from);
  if (!value) {
    throw new Error('from ID is undefined');
  }
  return value;
}

/**
 * Used to transform an object with an `id` or `_id` to a string ID.
 * In past versions the createdBy and updatedBy properties (and others)
 * had been a UserInfo object. Now it's just an ID (ObjectId).
 * To still support the older data, we use this helper.
 * TODO: Might be removed at a later time when everything is just an ID.
 *
 * @param from An id string or an object with an id, or undefined.
 * @returns
 */
export function legacyId(from: any): string | undefined {
  if (!from) {
    return from;
  }

  if (typeof from === 'string') {
    return from;
  }

  if (typeof from === 'object') {
    if (Object.prototype.hasOwnProperty.call(from, 'id')) {
      return from['id'].toString();
    }

    if (Object.prototype.hasOwnProperty.call(from, '_id')) {
      return from['_id'].toString();
    }
  }
  return from.toString();
}

export function legacyIdPatch(obj: any) {
  if (obj && typeof obj === 'object') {
    if ('createdBy' in obj) {
      obj['createdBy'] = legacyId(obj['createdBy']);
    }

    if ('updatedBy' in obj) {
      obj['updatedBy'] = legacyId(obj['updatedBy']);
    }
  }
}
